export default __webpack_public_path__ + "static/media/IvyMode-Regular.fde4ae54.woff2";